import styled from 'styled-components';
import { beam } from '@styles/colors/themes';
import COLORS_FLAT from '@styles/colors/themes/beam/beam-flat';
import { typeCSS } from '@utils/TypeCSS.styles';
import TYPOGRAPHY_FLAT from '@styles/fonts/fontsizes/typography-flat';
import { ButtonStylesNames, ButtonStylesParams, Styles } from '@mantine/core';
import { omit } from '@utils/omit';

export { Container } from '@components/Filters/FilterUpdates/components/MenuContent/MenuContent.styles';

export const FilterDiv = styled.div`
  flex-direction: row;
  display: flex;
  align-items: center;
  margin-left: 13px;
  & .MuiFormControlLabel-root {
    margin-right: 8px !important;
  }
  &&[data-position='0'] {
    margin-top: 10px; // extra.
  }
`;
export const Header = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  margin-bottom: 16px;
  h2 {
    ${typeCSS(TYPOGRAPHY_FLAT.h600)}
    margin: 0;
  }
`;
Header.displayName = 'Header';
export const Line = styled.div`
  height: 0;
  width: 100%;
  margin-bottom: 16px;

  border-top: 1px solid ${beam.border.back};
`;
Line.displayName = 'Line';
export const Input = styled.input`
  border-radius: 8px;
  border: 1px solid #e9edf1;
  background: #fff;
  color: #838a91;
  font-size: 16px;
  padding: 5px 12px;
  width: 100%;
`;
interface IItem {
  active: boolean;
}

export const Item = styled.div<IItem>`
  padding: 4px 8px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  background: ${({ active }) => (active ? '#F6F8FF' : '#fff')};
  cursor: pointer;
`;

interface IItemListText {
  active: boolean;
}

export const ItemListText = styled.div<IItemListText>`
  font-size: 14px;
  flex: 1;
  color: ${({ active }) => (active ? '#1371FE' : '#1a1b1c')};
`;

export const Buttons = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
`;

export const Cancel = styled.button`
  background: none;
  border: none;
  color: ${COLORS_FLAT.n800};
  padding: 10px 16px;
  transition: 0.2s;
  ${typeCSS(TYPOGRAPHY_FLAT.b200)}
  :hover {
    border-radius: 8px;
    background-color: ${COLORS_FLAT.n100};
  }
  &:disabled {
    pointer-events: none;
    cursor: not-allowed;
    color: ${COLORS_FLAT.n500};
  }
`;
export const BlueCancel = styled(Cancel)`
  color: ${COLORS_FLAT.b401};
  :hover {
    background-color: ${COLORS_FLAT.b100};
  }
`;
export const ConfirmButton = styled(BlueCancel)`
  margin-left: auto;
  &.with-margin {
    margin-top: 8px;
  }
`;
export function SubtleButton(): Styles<ButtonStylesNames, ButtonStylesParams> {
  return () => {
    return {
      root: {
        '&:hover': {
          backgroundColor: COLORS_FLAT.b100,
        },
        borderRadius: 8,
        border: 0,
        height: 'unset',
        // app font size overrides this, hence *
        '&, & *': {
          ...omit(TYPOGRAPHY_FLAT.b200, ['color']),
        },
        '&[data-disabled],&:disabled': {
          color: COLORS_FLAT.n500,
          backgroundColor: 'transparent',
        },
      },
    };
  };
}
